import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';

interface Params {
    shopId: string;
}

declare module '@stackflow/config' {
    interface Register {
        ItemSoldOutModal: Params;
    }
}

const ItemSoldOutModal: ActivityComponentType<'ItemSoldOutModal'> = ({ params }) => {
    const { shopId } = params;
    const { replace } = useFlow();
    return (
        <AppModal deny='취소'
            confirm='확인'
            onConfirm={() => replace('ItemsActivity', { shopId, type: 'ALL' })} >
            <Text size='title' align='center'>
                해당 상품 주문이 어렵습니다.<br/>
                해당 매장에서 다른 상품을 주문하시겠습니까?
            </Text>
        </AppModal>
    );
};

export default ItemSoldOutModal;
